export default [
  {
    activation_message:
      "Vi har sendt dig en mail med en aktiveringskode. Du kan finde aktiveringskoden i din indbakke eller i spam.",
    add: "Tilføj",
    address: "Adresse",
    back: "Tilbage",
    cancel: "Annuller",
    cart: "Indkøbskurv",
    shoppingCart: "Se bestilling",
    change: "Rediger",
    change_store: "Skift lokation",
    check_user: "Tjek bruger",
    close: "Lukket",
    btnClose: "Luk",
    code: "Kode",
    confirm: "Bekræft",
    default: "Standard",
    delete: "Slet",
    delete_all_cart: "Vil du slette varerne i indkøbskurven?",
    delete_all_items: "Slet alle varer",
    delivery: "Levering",
    details: "Info",
    edit: "Rediger",
    go_back: "Gå tilbage",
    go_to_homepage: "Gå til forsiden",
    login: "Log på",
    logout: "Log ud",
    maximum: "Maksimum",
    minimum: "Minimum",
    minute: "Minut",
    minutes: "Minutter",
    no: "Ingen",
    order: "Bestil",
    phone: "Telefon",
    pickup: "Afhentning",
    pusher_unavailable:
      "Kanalen til at modtage ordrer er brudt. Tjek din internet forbindlese eller kontakt venligst support.",
    quantity: "Antal",
    registration: "Registrering",
    remove_item_cart_description: "Den bliver helt fjernet fra kurven",
    remove_item_cart_question_title: "Vil du fjerne %{qty} X %{productname}?",
    restaurant: "Restaurant",
    send_email: "Send email",
    sign_up: "Opret Profil",
    update: "Opdatering",
    update_notification: "En opdatering er tilgængelig",
    variations: "Variationer",
    yes: "Ja",
    reset_code: "Nulstil kode",
    only_schedule_orders: "Kun forudbestillinger",
    open_today: "Åben i dag: ",
    open_now: "Åbn nu",
    closed: "Lukket",
    termAndCondition: "Handelsbetingelser",
    privacyPolicy: "Privatlivspolitik",
    confirmTable: "Dit bord blev ikke fundet",
    findMyTable: "Find mit bord",
    findMyTablePlaceholder: "Indtast din kode her",
    findMyTableDesc:
      "Hvis dit bord ikke kan findes ved søgning, så bør du kontakte personalet direkte",
    confirmTableDesc:
      "Du er landet på denne side fordi vi ikke kunne finde dit bord",
    about: "Om",
    free: "Gratis",
    warnTwitter:
      "Handling påkræves! Vi har sendt dig en mail, grundet sikkerheds opdatering med jeres stripe nøgler, for at undgå fejl med betalinger, så bedes du tage kontakt hurtigst muligt”",
  },
];
